var Noop = function () { };
var globalConfigs = {
    disableShake: false,
    reportTrigger: null,
    customReport: null,
    onReportFinished: Noop,
    devMode: false,
    consoleLogan: false,
    disablePreReport: false,
    disableKNB: false
};
var ConfigTypes;
(function (ConfigTypes) {
    ConfigTypes["disableShake"] = "boolean";
    ConfigTypes["reportTrigger"] = "object";
    ConfigTypes["customReport"] = "object";
    ConfigTypes["onReportFinished"] = "function";
    ConfigTypes["devMode"] = "boolean";
    ConfigTypes["consoleLogan"] = "boolean";
    ConfigTypes["disablePreReport"] = "boolean";
    ConfigTypes["disableKNB"] = "boolean";
})(ConfigTypes || (ConfigTypes = {}));
export default {
    set: function (configOb) {
        var newConfig = configOb || {};
        for (var property in ConfigTypes) {
            var newValue = newConfig[property];
            if (newValue !== undefined && typeof newValue === ConfigTypes[property]) {
                globalConfigs[property] = newConfig[property];
            }
        }
    },
    get: function (propertyKey) {
        return globalConfigs[propertyKey];
    }
};
